import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";
import { getViewportWidth } from "../../../../utils/getViewportWidth";
import { i18nProvider } from "@trumpf/ux.i18n";

export const renderMachineName = ({
    item,
    columnKey,
    schemaItem,
}: TableCellProps) => {
    const isMobile = getViewportWidth() < 768;
    const { t } = i18nProvider;
    return (
        <td class={schemaItem.className} data-testid={columnKey}>
            {item.orderTracking && (
                <div class="order-tracking-bar ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase">
                    {t("orderTracking.label")}
                </div>
            )}
            <div class="ux-u-d-flex ux-u-flex-ai-center">
                {item.discontinued !== undefined && (
                    <ux-iws-discontinuation-icon
                        tooltip-identifier={item.number}
                        type={item.discontinued.type}
                        status={item.discontinued.status}
                        extended-support={item.discontinued.extendedSupport}
                    ></ux-iws-discontinuation-icon>
                )}
                {item.discontinued !== undefined && !isMobile && (
                    <ux-iws-discontinuation-tooltip
                        tooltip-identifier={item.number}
                        type={item.discontinued.type}
                        status={item.discontinued.status}
                        extended-support={item.discontinued.extendedSupport}
                        head={item.discontinued.head}
                        text={item.discontinued.text}
                        link={item.discontinued.link}
                        link-text={item.discontinued.linkText}
                    ></ux-iws-discontinuation-tooltip>
                )}
                <div class="ux-iws-stateful-table__cell--flex">
                    <div class="ux-text-normal">
                        {item.customName ? item.customName : item[columnKey]}
                    </div>
                    {item.customName && (
                        <div class="ux-text-normal ux-iws-stateful-table__cell--machine-name">
                            {`(${item[columnKey]})`}
                        </div>
                    )}
                </div>
            </div>
        </td>
    );
};
